import React, { useEffect,useState } from "react";
import { FaChevronLeft, FaChevronRight, FaStar } from "react-icons/fa";
import GoogleIcon from '../images/google-icon.png';
import jananImg from '../images/review-persons/janan-hafza.png';
import owenImg from '../images/review-persons/owen.png';
import FLFImg from '../images/review-persons/FLF.png';
import micaelaImg from '../images/review-persons/micaela.png';
import oliviaImg from '../images/review-persons/olivia.png';
import AlexiaImg from '../images/review-persons/alexia.png';
import SamanthaImg from '../images/review-persons/samantha.png';
import HarjinderImg from '../images/review-persons/harjinder.png';
import MichaelImg from '../images/review-persons/michael.png';
import NedImg from '../images/review-persons/ned.png';
import DhristiImg from '../images/review-persons/dhristi.png';

const Reviews = () => {
   const [index, setIndex] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(3);
  const [expanded, setExpanded] = useState({});


  const reviews = [
    {
      name: "Janan Hafza",
      date: "3 days ago",
      text: "Always available, know what they are doing and is a one stop shop for all accounting needs of my medical practice.",
      rating: 5,
      avatar: jananImg,
    },
    {
      name: "Owen Simwanza",
      date: "a month ago",
      text: "Lalji is very professional and offers precise tailored services. I will always recommend their services to everyone who needs accounting services.",
      rating: 5,
      avatar:owenImg,
    },
    {
      name: "FLF Social",
      date: "2 months ago",
      text: "Extraordinarily kind and helpful. Definitely recommend for both personal and business tax. The wife and I were really happy",
      rating: 5,
      avatar: FLFImg,
    },
    {
      name: "Micaela Resurreccion",
      date: "2 months ago",
      text: "Highly recommend Lalji! He walked me through everything and ensured I was well informed with my personal and business taxes. He even took the time to let me know what steps I can take in the future so I'm on top of it all and answered every question I had. My partner and other colleagues have also completed their tax return with Lalji and left happy. We all definitely recommend him!",
      rating: 5,
      avatar: micaelaImg,
    },
    {
      name: "Olivia Moodley",
      date: "2 months ago",
      text: "Lalji was fantastic to work with, he made everything so easy to understand and really took the time to walk me through both my personal and business taxes. He explained how everything works in a clear, patient way and was always kind and professional. I genuinely felt supported throughout the whole process. Highly recommend his services!.",
      rating: 5,
      avatar: oliviaImg,
    },
     {
      name: "Alexia Clarke",
      date: "3 months ago",
      text: "I’ve been working Lalji for a while now and I honestly couldn’t be happier with the service. He is always super knowledgeable, responsive, and explain things in a way that actually makes sense. As a small business owner, it’s such a relief to know my finances are in expert hands. Highly recommend to anyone needing an accountant who genuinely cares and gets results.",
      rating: 5,
      avatar: AlexiaImg,
    },
     {
      name: "Samantha",
      date: "3 months ago",
      text: "I recently had the pleasure of working with Lalji and was thoroughly impressed by his professionalism and expertise. Despite a tight deadline, he completed all the necessary work within a short period of time and was able to complete it well ahead of schedule - which eased my stress and pressure.Lalji took the time to walk me through the entire process, ensuring I understood everything along the way. His clear communication and knowledgeable guidance made a big difference.I highly recommend Lalji to anyone seeking a reliable and efficient accountant.",
      rating: 5,
      avatar: SamanthaImg,
    },
    {
      name: "Harjinder Singh",
      date: "5 months ago",
      text: "Professional service received . Very informative and polite .",
      rating: 5,
      avatar: HarjinderImg,
    },
     {
      name: "Michael Ibe",
      date: "5 months ago",
      text: "Amazing Accounting Company. The very best. Lalji Patel is really professional and very helpful. He was able to solve all of my accounting problems.",
      rating: 5,
      avatar: MichaelImg,
    },
     {
      name: "Ned Brennan",
      date: "7 months ago",
      text: "Lalji was very helpful!",
      rating: 5,
      avatar: NedImg,
    },
     {
      name: "Dhristi Manji",
      date: "8 months ago",
      text: "I’ve been using Lalji Patel for my tax returns, and I couldn’t be happier with the service. They are professional, knowledgeable, and make what can be a stressful process so much easier. He explains everything clearly and ensures that all my paperwork is in order, giving me confidence that nothing has been overlooked.Not only is Lalji thorough and efficient, but he also takes the time to answer any questions I have. I always feel like I’m in good hands. If you’re looking for someone to handle your tax returns smoothly and with expertise, I highly recommend him!",
      rating: 5,
      avatar: DhristiImg,
    },
  ];

  useEffect(() => {
    const updateCards = () => {
      if (window.innerWidth <= 600) setCardsPerView(1);
      else if (window.innerWidth <= 992) setCardsPerView(2);
      else setCardsPerView(3);
    };
    updateCards();
    window.addEventListener("resize", updateCards);
    return () => window.removeEventListener("resize", updateCards);
  }, []);

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % reviews.length);
  };

  const prevSlide = () => {
    setIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
  };


  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [cardsPerView]);


  const visibleReviews = [];
  for (let i = 0; i < cardsPerView; i++) {
    const current = (index + i) % reviews.length;
    visibleReviews.push(reviews[current]);
  }

  return (
      <div className="reviews-section">
      <div className="reviews-header">
        <div className="rating-summary">
          <h3>EXCELLENT</h3>
          <div className="stars">★★★★★</div>
          <p>Based on 158 reviews</p>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg"
            alt="Google"
            className="google-logo"
          />
        </div>

        <div className="slider-container">

          <div className="reviews-track">
            {visibleReviews.map((r, i) => (
              <div className="review-card" key={i}>
                <div className="review-top">
                  <img src={r.avatar} alt={r.name} className="avatar" />
                  <div>
                    <h4>{r.name}</h4>
                    <p className="date">{r.date}</p>
                  </div>
                  <img
                src={GoogleIcon}
                alt="G"
                className="g-icon"/>



                </div>
                <div className="stars small">{"★".repeat(r.rating)}</div>
                <div 
  className={`review-text ${expanded[i] ? 'expanded' : ''}`}
>
  {expanded[i] ? r.text : `${r.text.substring(0, 100)}`} 
  {r.text.length > 100 && (
    <button 
      className="read-more-btn"
      onClick={() => setExpanded(prev => ({ ...prev, [i]: !prev[i] }))}
    >
      {expanded[i] ? "Show Less" : "Read More"}
    </button>
  )}
</div>

              </div>
            ))}
          </div>
            <div className="slider-dots">
  {reviews.map((_, i) => (
    <span
      key={i}
      className={`dot ${index === i ? "active" : ""}`}
      onClick={() => setIndex(i)}
    />
  ))}
</div>
        </div>
      </div>
    </div>
  );
  
};

export default Reviews;
